module.exports = __webpack_public_path__ + "static/image-2a0da8705758dfb87a12707d7a9a704e.jpg";